<template>
	<section>
		<!--工具条-->		
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="开始时间">
					<el-date-picker
						v-model="filters.entimes"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item label="结束时间">
					<el-date-picker
						v-model="filters.entimee"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item label="广告平台">
					<el-select 
						v-model="filters.scode" filterable placeholder="选择广告平台" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.scode" :label="item.sname" v-model="item.scode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.cpcode" filterable placeholder="请选择渠道" class="h-m-select">
					  <el-option v-for="item in cplist"
						:key="item.code" :label="item.name" v-model="item.code">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="filters.showtime">显示时间</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="filters.showspinfo">显示上游</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="filters.showcpinfo">显示渠道</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="filters.showsite">显示Site</el-checkbox>
				</el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				<el-button type="primary" icon="el-icon-search" @click="clarnQuery">清空条件</el-button>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :header-cell-style="{ background: '#999999', color: '#000' }" 
			:data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:95%;" height="500"
			:summary-method="formatXxfUp" show-summary>
			<el-table-column label="----" min-width="30" v-if="filters.noShowColTable"></el-table-column>
			<el-table-column prop="date" label="Daily" min-width="60" v-if="filters.showtimeTable"></el-table-column>
			<el-table-column prop="spname" label="上游" min-width="60" v-if="filters.showspinfoTable"></el-table-column>
			<el-table-column prop="cpname" label="渠道" min-width="60" v-if="filters.showcpinfoTable"></el-table-column>
			<el-table-column prop="site" label="site" min-width="100" v-if="filters.showsiteTable"></el-table-column>
			<el-table-column prop="requests" label="请求" min-width="60"></el-table-column>
			<el-table-column prop="pp_requests" label="填充" min-width="60"></el-table-column>
			<el-table-column prop="fill_rate" label="填充率" min-width="60"></el-table-column>
			<el-table-column prop="imp" label="展示" min-width="60"></el-table-column>
			<el-table-column prop="imp_rate" label="展示率" min-width="60"></el-table-column>
			<el-table-column prop="click" label="点击" min-width="60"></el-table-column>
			<el-table-column prop="ctr" label="CTR(%)" min-width="60"></el-table-column>
			<el-table-column prop="publisher_cpc" label="CPC" min-width="60"></el-table-column>
			<el-table-column prop="publisher_cpm" label="ECPM" min-width="60"></el-table-column>
			<el-table-column prop="net_revenue" label="分成前" min-width="60"></el-table-column>
			<el-table-column prop="publisher_revenue" label="分成后" min-width="60"></el-table-column>
		</el-table>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					entimes:'',
					entimee:'',
					codes:'',
					scode:'',
					cpcode:'',
					showtime:false,
					showtimeTable:false,
					showsite:false,
					showsiteTable:false,
					noShowColTable:false,
					showspinfo:false,
					showspinfoTable:false,
					showcpinfo:false,
					showcpinfoTable:false,
				},
				splist:[],
				cplist:[],
				datalist: [],
				tgsList:[],
				service_options:[],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				timer:null, //定时器名称
			}
		},
		methods: {
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_spinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getCpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_cpinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.cplist = res.data.datas;
					}
				});
				
			},
			clarnQuery:function(){
				this.filters.scode = '';
				this.filters.cpcode = '';
			},
			getLists:function(){
				let para = {
					entimes:this.filters.entimes,
					entimee:this.filters.entimee,
					codes:this.filters.codes,
					scode:this.filters.scode,
					cpcode:this.filters.cpcode,
					actionurl:'datas/getList'
				};
				
				if(this.filters.showtime){
					para.showtime = 1 ;
				}
				if(this.filters.showsite){
					para.showsite = 1 ;
				}
				if(this.filters.showspinfo){
					para.showspinfo = 1 ;
				}
				if(this.filters.showcpinfo){
					para.showcpinfo = 1 ;
				}
				
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.filters.showtimeTable = this.filters.showtime ;
						this.filters.showsiteTable = this.filters.showsite;
						this.filters.showspinfoTable = this.filters.showspinfo;
						this.filters.showcpinfoTable = this.filters.showcpinfo;
						
						console.log(">>>"+this.filters.showspinfo);
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					
					this.listLoading = false;
					//NProgress.done();
				});
			},
			formatXxfUp: function (param) {
				const { columns, data } = param;
				const sums = [];
				var noSumIndex = -1 ;
				if(this.filters.showtimeTable) noSumIndex++;
				if(this.filters.showsite) noSumIndex++;
				if(this.filters.showspinfo) noSumIndex++;
				if(this.filters.showcpinfo) noSumIndex++;
				if(noSumIndex<0) {
					this.filters.noShowColTable = true;
					noSumIndex++;
				}else{
					this.filters.noShowColTable = false;
				}
				
				columns.forEach((column, index) => {
				  if (index <=noSumIndex) {
					return ;
				  }
				  if(index==noSumIndex+3||index==noSumIndex+5||index==noSumIndex+7||index==noSumIndex+9){
					return ;
				  }
				  //////////////////////
				  const values = data.map(item => Number(item[column.property]));
				  if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
					  const value = Number(curr);
					  if (!isNaN(value)) {
						return prev + curr;
					  } else {
						return prev;
					  }
					}, 0);
				  } else {
					sums[index] = 'N/A';
				  }
				});
				if(noSumIndex>=0) sums[noSumIndex] = '合计';
				try{
					sums[noSumIndex+3] = (sums[noSumIndex+2]*100/sums[noSumIndex+1]).toFixed(2)+'%';
				}catch(e){}
				try{
					sums[noSumIndex+5] = (sums[noSumIndex+4]*100/sums[noSumIndex+2]).toFixed(2)+'%';
				}catch(e){}
				try{
					sums[noSumIndex+7] = (sums[noSumIndex+6]*100/sums[noSumIndex+4]).toFixed(2)+'%';
				}catch(e){}
				try{
					sums[noSumIndex+9] = ((sums[noSumIndex+10])*1000/sums[noSumIndex+4]).toFixed(2);
				}catch(e){}
				try{
					//sums[noSumIndex+7] = sums[noSumIndex+7].toFixed(2)+'';
				}catch(e){}
				try{
					sums[noSumIndex+10] = sums[noSumIndex+10].toFixed(2)+'';
				}catch(e){}
				return sums;
			},
			actTimeQuery:function(){
				let para = {
					actionurl:'datas/refreshData'
				};
				getListPage(para).then((res) => {
					if(res.data.status == 200){
						console.log("会话激活!");
						//this.timer = setInterval(() => {
						//   setTimeout(this.actTimeQuery, 0)
						//}, 1000*60)
					}else{
						//失败
						console.log("会话过期!");
					}
				});
			}
		},
		mounted() {
			this.getSpList();
			this.getCpList();
			this.filters.entimes = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
			this.filters.entimee = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
			this.getLists();
			this.timer = setInterval(() => {
			   setTimeout(this.actTimeQuery, 0)
		    }, 1000*60);
		},
		beforeDestroy(){
			clearInterval(this.timer);        
			this.timer = null;
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Rtreport9933.vue?152d7272